module.exports = __webpack_public_path__ + "static/media/eliane_penha_mergulhao_dias.d2da436d.jpg";